<template>
  <!-- <div class="Scan_the_QR_code"> -->
  <van-dialog v-model="showScanCode"
              className="ScanQRCode_dia"
              title="扫描二维码"
              show-cancel-button
              :show-confirm-button="false"
              :before-close="closeDia">
    <div class="scan_content">
      <van-loading class="loadingVid"
                   v-if="loadingVid"
                   size="24px"
                   color="#0094ff"
                   vertical>加载中...</van-loading>
      <video id="scanVideo"
             width="350"
             height="486"
             autoplay></video>
    </div>
  </van-dialog>
  <!-- </div> -->
</template>

<script>
import { Toast } from 'vant'
export default {
  data () {
    return {
      showScanCode: false,
      loadingVid: false,
      mediaStream: null,
      scanTime: null
    }
  },
  watch: {
    showScanCode (n) {
      if (n)
      {
        this.loadingVid = true
        setTimeout(() => {
          this.startCamera()
        }, 1000);
      } else
      {
        // 关闭摄像头
        if (this.mediaStream)
        {
          this.mediaStream.getTracks().forEach(el => {
            el.stop()
          });
        }
        clearInterval(this.scanTime)
        this.scanTime = null
      }
    }
  },
  methods: {
    startScanning () {
      this.scanQRCode(); // 首次尝试扫描
      this.scanTime = setInterval(this.scanQRCode, 1000); // 每秒扫描一次视频帧
    },
    startCamera () {
      try
      {
        const videoElement = document.getElementById('scanVideo');
        let _this = this
        navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: 'environment' } }).then(stream => {
          // console.log(stream, 'streamstreamstreamsssssssssss');
          _this.loadingVid = false
          _this.mediaStream = stream
          videoElement.srcObject = stream
          videoElement.onloadedmetadata = function (e) {
            videoElement.play()
          }
          setTimeout(() => {
            if (_this.mediaStream)
            {
              _this.startScanning()
            }
          }, 1000);
        }).catch(err => {
          Toast.fail('访问摄像头异常：' + err.message)
        })
      } catch (error)
      {
        Toast.fail('访问摄像头异常：' + error)
        console.error("Error accessing the camera.", error);
      }
    },
    scanQRCode () {
      const video = document.getElementById('scanVideo');
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      // console.log(imageData, 'imageDataimageDataimageData')
      const jsQR = require('jsqr')
      const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: "dontInvert", // or "turnInvert" or "reckless"
      });
      if (code)
      {
        Toast('扫描成功！')
        this.$emit('getQRCodeContent', code.data)
        this.showScanCode = false
        // alert('扫描成功：' + code.data)
        // console.log("Found QR code:", code.data); // 输出二维码数据
      } else
      {
        console.log("No QR code found."); // 未找到二维码时输出此消息
      }
    },
    closeDia (action, done) {
      if (action == 'confirm')
      {
      } else
      {
        this.showScanCode = false
        done()
      }
    }
  }
}
</script>

<style lang="less">
// .Scan_the_QR_code {
//   height: 80%;
.ScanQRCode_dia {
  height: 70%;
  width: 90%;
  .van-dialog__header {
    display: block !important;
    height: 100px;
    padding-top: 0;
    line-height: 100px;
  }
  .van-dialog__content {
    width: 100%;
    height: calc(100% - 200px) !important;
    overflow: hidden;
    .scan_content {
      width: 100%;
      height: 100%;
      position: relative;
      .loadingVid {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        justify-content: center;
      }
    }
  }
  .van-dialog__footer {
    height: 100px;
  }
}
// }
</style>